import { createRouter, createWebHistory } from 'vue-router'

import { useAuthStore } from '@/store/auth.ts'
const routes = [
  {
    path: '/',
    name: 'base',
    beforeEnter: async () => {
      await useAuthStore().verifyCurrentSession()
    },
    children: [
      {
        path: '',
        component: () => import('@/layouts/AppLayout.vue'),
        name: 'home',
        children: [
          {
            path: '',
            beforeEnter: async () => {
              await useAuthStore().guardContractorRoutes()
            },
            children: [
              {
                path: '',
                name: 'contractor',
                component: () => import('@/views/app/contractor/ContractorLandingPage.vue'),
              },
              {
                path: 'orientation/:section_id?',
                name: 'orientation',
                component: () => import('@/views/app/contractor/ContractorDashboard.vue'),
                props: true,
              },
            ],
          },
          {
            path: 'admin',
            beforeEnter: async () => {
              await useAuthStore().guardAdminRoutes()
            },
            children: [
              {
                path: '',
                name: 'admin',
                component: () => import('@/views/app/admin/AdminDashboard.vue'),
              },
              {
                path: 'edit-orientation',
                name: 'admin/edit-orientation',
                component: () => import('@/views/app/admin/EditOrientation.vue'),
              },
            ],
          },
          {
            beforeEnter: async () => {
              await useAuthStore().guardManagerRoutes()
            },
            path: 'manager',
            children: [
              {
                path: '',
                name: 'manager',
                component: () => import('@/views/app/manager/ManagerDashboard.vue'),
              },
            ],
          },
        ],
      },
      {
        path: '/',
        component: () => import('@/layouts/AuthLayout.vue'),
        children: [
          {
            path: 'email-verification',
            name: 'email-verification',
            component: () => import('@/views/auth/EmailVerification.vue'),
          },
          {
            path: 'forgot-password',
            component: () => import('@/views/auth/ForgotPassword.vue'),
            name: 'forgot-password',
          },
          {
            path: 'reset-password',
            component: () => import('@/views/auth/ResetPassword.vue'),
            name: 'reset-password',
          },
          {
            path: 'signin',
            component: () => import('@/views/auth/SignIn.vue'),
            name: 'signin',
          },
          {
            path: 'signup',
            component: () => import('@/views/auth/SignUp.vue'),
            name: 'signup',
          },
        ],
      },
    ],
  },
  {
    path: '/logout',
    redirect: () => {
      useAuthStore().logout()

      return { name: 'signin' }
    },
    name: 'logout',
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  linkActiveClass: '-active',
  linkExactActiveClass: '-exact-active',
  routes: routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
        top: 20,
      }
    }
    return { top: 0, behavior: 'smooth' }
  },
})

export default router
